export const UnitsTableHeader = ({ handleSort }) => {
  const columns = [
    { key: 'unit', label: 'UNIT' },
    { key: 'status', label: 'STATUS' },
    { key: 'since_last_score', label: 'LAST SCORE' },
    { key: 'lastLoginTimestamp', label: 'LAST LOGIN' },
    { key: 'daily_unit_use', label: 'DAILY USE' },
    { key: 'total_kpod_use', label: 'TOTAL CYCLES', className: 'mobile-hidden' },
    { key: 'next_replacement', label: 'NEXT REPLACEMENT', className: 'mobile-hidden' },
    { key: 'score_trend', label: 'SCORE TREND', className: 'mobile-hidden' }
  ];

  return (
    <thead className="table-dark rounded-top">
      <tr>
        {columns.map(({ key, label, className }) => (
          <th 
            key={label}
            className={`align-middle py-0 ${className || ''}`} 
            onClick={() => handleSort(key)}
          >
            {label}
          </th>
        ))}
      </tr>
    </thead>
  );
};